import { Site } from "./site";
import { Constants } from "../config/constants";
export default (site: Site) => site.status === Constants.roles.manager.id;
